import { STORAGE_KEYS } from './constants';

/**
 * Helper functions to manage pond ID lifecycle in localStorage
 * All functions require userId to scope storage per user
 *
 * Rules:
 * 1. Save pond ID when user selects a pond from water quality dropdown
 * 2. Clear pond ID when user switches to a different farm
 * 3. Maintains state when switching between tabs within same farm
 */

/**
 * Save the selected pond ID to localStorage (user-scoped)
 * This allows pond selection to persist when switching between tabs
 */
export function savePondId(userId: string, pondId: string): void {
  localStorage.setItem(STORAGE_KEYS.lastPondId(userId), pondId);
}

/**
 * Get the saved pond ID from localStorage (user-scoped)
 */
export function getSavedPondId(userId: string): string | null {
  return localStorage.getItem(STORAGE_KEYS.lastPondId(userId));
}

/**
 * Clear the saved pond ID from localStorage (user-scoped)
 * Should be called when user switches farms
 */
export function clearPondId(userId: string): void {
  localStorage.removeItem(STORAGE_KEYS.lastPondId(userId));
}

/**
 * Check if a pond ID is currently saved (user-scoped)
 */
export function hasSavedPondId(userId: string): boolean {
  return getSavedPondId(userId) !== null;
}

// === Farm ID helpers (user-scoped) ===

/**
 * Save the selected farm ID to localStorage (user-scoped)
 */
export function saveFarmId(userId: string, farmId: string): void {
  localStorage.setItem(STORAGE_KEYS.lastFarmId(userId), farmId);
}

/**
 * Get the saved farm ID from localStorage (user-scoped)
 */
export function getSavedFarmId(userId: string): string | null {
  return localStorage.getItem(STORAGE_KEYS.lastFarmId(userId));
}

/**
 * Clear the saved farm ID from localStorage (user-scoped)
 */
export function clearFarmId(userId: string): void {
  localStorage.removeItem(STORAGE_KEYS.lastFarmId(userId));
}
